import { useState } from "react";
import type { TaskProps } from "../../../types/TaskProps";
import { CommonUserTaskNew } from "../CommonUserTaskNew";
import VideoIdView from "../video-id";
import { ApplicantInfo } from "../../../components/Applicant/ApplicantInfo";
import { RadioButtonGroup } from "../../../components/Decision/RadioButtonGroup";
import { FormTextArea } from "../../../components/Input/FormTextArea";

const ManualVideoIdFollowUp = (props: TaskProps) => {
  const { flow, user, task, complete, save } = props;
  const { flowId } = flow;
  const videoId = flow?.data?.integrations?.electronicIdVideoId;
  const hasCoApplicant = !!flow?.data?.agentApiApplication?.coapplicant;
  const applicantInfo = flow?.data?.agentApiApplication?.applicant;
  const coApplicantInfo = flow?.data?.agentApiApplication?.coapplicant
    ? {
        ...flow?.data?.agentApiApplication?.coapplicant,
        isCoApplicant: true,
      }
    : null;
  const decisionErrorMessage = "Please select a decision.";
  const noErrorMessage = "";
  const [errorMessages, setErrorMessages] = useState<string>(noErrorMessage);
  const [comment, setComment] = useState<string>(task?.data?.comment ?? "");
  const [decision, setDecision] = useState<boolean | "">(
    task?.data?.decision ?? "",
  );
  const onComplete = () => {
    if (decision === "") {
      setErrorMessages(decisionErrorMessage);
      return;
    }
    if (errorMessages === decisionErrorMessage) {
      setErrorMessages(noErrorMessage);
    }
    if (errorMessages !== noErrorMessage) {
      return;
    }
    const formData = {
      decision,
      comment,
    };
    complete(
      formData,
      () => {},
      (e: any) => {
        setErrorMessages(e?.detail);
      },
    );
  };
  const onSave = async () => {
    const formData = {
      decision,
      comment,
    };
    props.save(
      formData,
      () => {},
      (error: any) => console.error({ error }),
      true,
    );
  };
  const infoConfig = [
    {
      component: (
        <div style={{ width: "60vw", height: "60vh" }}>
          <VideoIdView videoId={videoId} flowId={flowId} />
        </div>
      ),
      order: 1,
    },
  ];
  const formConfig = [
    {
      component: (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <ApplicantInfo applicant={applicantInfo} />
          {hasCoApplicant && <ApplicantInfo applicant={coApplicantInfo} />}
        </div>
      ),
      order: 1,
    },
    {
      component: (
        <RadioButtonGroup
          radioButtonValue={decision}
          onChange={(e: any) => setDecision(e)}
          title="Decision"
          options={[
            { value: "retry", label: "Retry Video ID" },
            { value: "declined", label: "Decline application" },
          ]}
          id="check-manual-handling"
        />
      ),
      order: 2,
    },
    {
      component: (
        <FormTextArea
          name="Comment"
          onChange={(e: string) => setComment(e)}
          label="Comment"
          defaultValue={comment || ""}
        />
      ),
      order: 3,
    },
  ];
  return (
    <CommonUserTaskNew
      handleComplete={onComplete}
      handleSave={onSave}
      infoConfig={infoConfig}
      formConfig={formConfig}
    />
  );
};

export default ManualVideoIdFollowUp;
